"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncTcoSystemStatusDates = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.syncTcoSystemStatusDates = (0, graphql_tag_1.default) `
  mutation SyncTcoSystemStatusDatesMutation($tcoId: ID!) {
    syncTcoSystemStatusDates(tcoId: $tcoId) {
      id
      errorMessage
    }
  }
`;
//# sourceMappingURL=sync-tco-system-status-dates.js.map